import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

export class FormArrayValidators {

  public static minNotNullChildren(min: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!(control instanceof FormArray)) {
        return null;
      }
      const array = control;
      const notNullChildren = array.controls.filter(c => c.value).length;
      return (notNullChildren < min) ? { 'minNotNullChildren': { value: control.value } } : null;
    };
  }

  public static maxNotNullChildren(max: number): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!(control instanceof FormArray)) {
        return null;
      }
      const array = control;
      const notNullChildren = array.controls.filter(c => c.value).length;
      return (notNullChildren > max) ? { 'maxNotNullChildren': { value: control.value } } : null;
    };
  }

}
